var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import Button from '@fp-suite/core-ui/src/components/Button';
import QuickQueueList from './QuickQueueList';
import LocationSearchDropdown from './LocationSearchDropdown';
import { PhotoAttachField } from '../camera';
var RECEIVING_TYPES = ['FltReceiving', 'FltBulk', 'FltPick'];
var MORGUE_TYPES = ['FltMorgue'];
var QuickReceiveSidebar = function (_a) {
    var queue = _a.queue, suggestedLocations = _a.suggestedLocations, amazonAws = _a.amazonAws, isSubmitting = _a.isSubmitting, initialLocationSeqId = _a.initialLocationSeqId, productLocationPreferences = _a.productLocationPreferences, _b = _a.preloadReceivingOptionsInLocationSearch, preloadReceivingOptionsInLocationSearch = _b === void 0 ? false : _b, _c = _a.allowReject, allowReject = _c === void 0 ? false : _c, images = _a.images, onImagesChange = _a.onImagesChange, buildImageName = _a.buildImageName, onRemoveRow = _a.onRemoveRow, onUpdateQty = _a.onUpdateQty, onValidateLocation = _a.onValidateLocation, onSearchLocations = _a.onSearchLocations, onReceive = _a.onReceive, computeOverReceiveTotal = _a.computeOverReceiveTotal;
    var t = useTranslation().t;
    var confirm = Modal.confirm;
    var _d = useState(''), selectedLocation = _d[0], setSelectedLocation = _d[1];
    var _e = useState(false), showMorguePicker = _e[0], setShowMorguePicker = _e[1];
    var _f = useState(''), morgueLocation = _f[0], setMorgueLocation = _f[1];
    var _g = useState(false), isCheckingMorgue = _g[0], setIsCheckingMorgue = _g[1];
    // Auto-fill from per-product preferences saved on previous submits.
    // Only fires when nothing is selected and a queued product has a
    // remembered location that is currently a valid suggestion.
    useEffect(function () {
        if (selectedLocation)
            return;
        if (suggestedLocations.length === 0)
            return;
        var _loop_1 = function (row) {
            var pref = productLocationPreferences[row.productId];
            if (pref &&
                suggestedLocations.some(function (loc) {
                    return loc.key === pref &&
                        (!allowReject ||
                            (!!loc.locationTypeEnumId && RECEIVING_TYPES.includes(loc.locationTypeEnumId)));
                })) {
                setSelectedLocation(pref);
                return { value: void 0 };
            }
        };
        for (var _i = 0, queue_1 = queue; _i < queue_1.length; _i++) {
            var row = queue_1[_i];
            var state_1 = _loop_1(row);
            if (typeof state_1 === "object")
                return state_1.value;
        }
    }, [queue, productLocationPreferences, suggestedLocations, selectedLocation, allowReject]);
    useEffect(function () {
        if (queue.length > 0)
            return;
        setShowMorguePicker(false);
        setMorgueLocation('');
    }, [queue.length]);
    var effectiveLocation = selectedLocation || initialLocationSeqId || '';
    var canReceive = queue.length > 0 && !!effectiveLocation && !isSubmitting && !isCheckingMorgue;
    var canReject = queue.length > 0 && !isSubmitting && !isCheckingMorgue;
    var handleReceiveClick = function (opts) { return __awaiter(void 0, void 0, void 0, function () {
        var locationSeqId, isDefective, overQty, submit;
        var _a;
        return __generator(this, function (_b) {
            locationSeqId = (opts === null || opts === void 0 ? void 0 : opts.locationSeqId) || effectiveLocation;
            isDefective = (_a = opts === null || opts === void 0 ? void 0 : opts.isDefective) !== null && _a !== void 0 ? _a : false;
            if (!queue.length || !locationSeqId || isSubmitting || isCheckingMorgue)
                return [2 /*return*/];
            overQty = computeOverReceiveTotal();
            submit = function () { return onReceive(locationSeqId, isDefective); };
            if (overQty > 0) {
                confirm({
                    title: _jsx("div", __assign({ className: 'text-red-600' }, { children: t('Over Receiving Alert') }), void 0),
                    icon: '',
                    content: (_jsxs("div", __assign({ className: 'font-semibold' }, { children: [t('You are over receiving by'), " ", overQty, " ", t('item(s).'), _jsx("br", {}, void 0), t('Are you sure?')] }), void 0)),
                    okText: t('Yes'),
                    cancelText: t('No'),
                    onOk: submit,
                    cancelButtonProps: { style: { borderRadius: '25px' } }
                });
            }
            else {
                void submit();
            }
            return [2 /*return*/];
        });
    }); };
    var isMorgueLocation = function (locationSeqId) { return __awaiter(void 0, void 0, void 0, function () {
        var knownType, result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!locationSeqId)
                        return [2 /*return*/, false];
                    knownType = (_a = suggestedLocations.find(function (loc) { return loc.key === locationSeqId; })) === null || _a === void 0 ? void 0 : _a.locationTypeEnumId;
                    if (knownType === 'FltMorgue')
                        return [2 /*return*/, true];
                    return [4 /*yield*/, onValidateLocation(locationSeqId)];
                case 1:
                    result = _b.sent();
                    return [2 /*return*/, result.ok && result.locationTypeEnumId === 'FltMorgue'];
            }
        });
    }); };
    var closeMorguePicker = function () {
        setShowMorguePicker(false);
        setMorgueLocation('');
    };
    var handleRejectClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!canReject)
                        return [2 /*return*/];
                    setIsCheckingMorgue(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 4, 5]);
                    _a = effectiveLocation;
                    if (!_a) return [3 /*break*/, 3];
                    return [4 /*yield*/, isMorgueLocation(effectiveLocation)];
                case 2:
                    _a = (_b.sent());
                    _b.label = 3;
                case 3:
                    if (_a) {
                        void handleReceiveClick({ locationSeqId: effectiveLocation, isDefective: true });
                        return [2 /*return*/];
                    }
                    setShowMorguePicker(true);
                    return [3 /*break*/, 5];
                case 4:
                    setIsCheckingMorgue(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleMorgueSelect = function (locationSeqId) {
        setMorgueLocation(locationSeqId);
        setShowMorguePicker(false);
        void handleReceiveClick({ locationSeqId: locationSeqId, isDefective: true });
    };
    return (_jsxs("div", __assign({ className: 'flex flex-col gap-3' }, { children: [_jsx("div", __assign({ className: 'flex flex-col overflow-hidden rounded-2xl bg-white shadow-sm', style: { minHeight: 150 } }, { children: _jsx(QuickQueueList, { queue: queue, amazonAws: amazonAws, onRemove: onRemoveRow, onUpdateQty: onUpdateQty }, void 0) }), void 0), onImagesChange && buildImageName && (_jsxs("div", __assign({ className: 'rounded-2xl bg-white p-4 shadow-sm' }, { children: [_jsxs("div", __assign({ className: 'flex items-center justify-between' }, { children: [_jsx("h3", __assign({ className: 'text-xs font-bold text-gray-700' }, { children: t('Images') }), void 0), _jsx(Tooltip, __assign({ title: t('Attach images to this shipment. They upload once you press Receive.') }, { children: _jsx(InfoCircleOutlined, { className: 'text-gray-400' }, void 0) }), void 0)] }), void 0), _jsx("div", __assign({ className: 'mt-2' }, { children: _jsx(PhotoAttachField, { files: images || [], onChange: onImagesChange, disabled: isSubmitting, label: String(t('Add Image')), modalTitle: String(t('Add Image')), buildFileName: buildImageName }, void 0) }), void 0)] }), void 0)), _jsxs("div", __assign({ className: 'rounded-2xl bg-white p-4 shadow-sm' }, { children: [_jsxs("div", __assign({ className: 'flex items-center justify-between' }, { children: [_jsx("h3", __assign({ className: 'text-xs font-bold text-gray-700' }, { children: t('Receiving Location') }), void 0), _jsx(Tooltip, __assign({ title: t('Suggested locations are based on where the product has been historically stored. Type or scan to find any Receiving, Bulk, or Pick location.') }, { children: _jsx(InfoCircleOutlined, { className: 'text-gray-400' }, void 0) }), void 0)] }), void 0), _jsx("div", __assign({ className: 'mt-2' }, { children: _jsx(LocationSearchDropdown, { preloadReceivingOptions: preloadReceivingOptionsInLocationSearch, locationTypes: allowReject ? RECEIVING_TYPES : undefined, suggestedLocations: suggestedLocations, isDisabled: isSubmitting || isCheckingMorgue, value: selectedLocation, onSearchLocations: onSearchLocations, onValidateLocation: onValidateLocation, onSelectLocation: function (val) { return setSelectedLocation(val); }, onClear: function () { return setSelectedLocation(''); } }, void 0) }), void 0), effectiveLocation && (_jsxs("p", __assign({ className: 'mt-3 text-xs text-gray-500' }, { children: [t('Receiving at'), ": ", _jsx("span", __assign({ className: 'font-semibold' }, { children: effectiveLocation }), void 0)] }), void 0))] }), void 0), allowReject && (_jsx(Modal, __assign({ title: String(t('Morgue Location')), visible: showMorguePicker, footer: null, destroyOnClose: true, onCancel: function () { return closeMorguePicker(); } }, { children: _jsx(LocationSearchDropdown, { locationTypes: MORGUE_TYPES, suggestedLocations: [], isDisabled: isSubmitting, autoFocus: true, value: morgueLocation, placeholder: String(t('Select a morgue location')), onSearchLocations: onSearchLocations, onValidateLocation: onValidateLocation, onSelectLocation: handleMorgueSelect, onClear: function () { return setMorgueLocation(''); } }, void 0) }), void 0)), allowReject ? (_jsxs("div", __assign({ className: 'flex gap-2' }, { children: [_jsx(Button, { buttonText: isSubmitting ? t('Receiving...') : t('Receive'), loading: isSubmitting, isDisabled: !canReceive, onClick: function () { return handleReceiveClick(); }, widthFull: true, paddingY: 'py-3' }, void 0), _jsx(Button, { buttonText: t('Reject'), loading: isCheckingMorgue, isDisabled: !canReject, onClick: handleRejectClick, defaultColor: 'bg-red-500', widthFull: true, paddingY: 'py-3' }, void 0)] }), void 0)) : (_jsx(Button, { buttonText: isSubmitting ? t('Receiving...') : t('Receive'), loading: isSubmitting, isDisabled: !canReceive, onClick: function () { return handleReceiveClick(); }, widthFull: true, paddingY: 'py-3' }, void 0))] }), void 0));
};
export default QuickReceiveSidebar;
